export default __webpack_public_path__ + "static/media/Hood of the Ravenflight.89852882.jpg";